import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import type * as core from '../../core'

/**
 * Standardized version of the leader type.
 */
export enum LeaderType {
  Manager = 'manager',
  IndirectManager = 'indirect-manager',
  Other = 'other',
}
// Needs to be before namespace is defined
const LEADER_TYPES: ReadonlySet<LeaderType> = new Set(
  Object.values(LeaderType) as LeaderType[],
)
export namespace LeaderType {
  export const ALL: readonly LeaderType[] = Array.from(LEADER_TYPES)
  export const isLeaderType = TypeChecker.Factory.oneOf(LEADER_TYPES)
  export const assertIsLeaderType: TypeAsserter<LeaderType> =
    TypeAsserter.Factory.from(isLeaderType)

  /**
   * Returns the {@link core.common.value.types.Enum.Entry} for the given
   * {@link LeaderType}
   */
  export function getEntry(
    leaderType: LeaderType,
  ): core.common.value.types.Enum.Entry {
    return { ...ENTRY_LOOKUP[leaderType], id: leaderType }
  }
  /** Used by {@link getEntry} */
  const ENTRY_LOOKUP: Record<
    LeaderType,
    Omit<core.common.value.types.Enum.Entry, 'id'>
  > = {
    [LeaderType.Manager]: {
      name: 'Manager',
    },
    [LeaderType.IndirectManager]: {
      name: 'Indirect Manager',
    },
    [LeaderType.Other]: {
      name: 'Other',
    },
  }
}
